















































































































import { cloneDeep } from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import Icon from '../../../../components/Icon/Icon.vue'
import { SelectOptionData } from '../../../Pi/types'
import SelectedTopicTag from './SelectedTopicTag.vue'
import TopicCard from './TopicCard.vue'

@Component({
  components: {
    Icon,
    SelectedTopicTag,
    TopicCard
  }
})
export default class TopicsSelect extends Vue {
  @Prop({ type: Object }) readonly topics!:{ items: Array<SelectOptionData>, limit: number }

  @Prop({ type: Array }) readonly selectedTopics!:Array<number>

  localTopics: Array<number> = []

  showModal = false

  @Emit()
  updateTopics():Array<number> {
    return cloneDeep(this.localTopics)
  }

  isTopicSelected(id:number) {
    return this.localTopics.includes(id)
  }

  handleCancel():void {
    this.setPiTopics()

    this.showModal = false
  }

  handleOkClick():void {
    this.updateTopics()

    this.showModal = false
  }

  resetTopics():void {
    this.localTopics = []
    this.showModal = false

    this.updateTopics()
  }

  setTopic(id:number):void {
    if (this.topics?.limit === undefined || this.topics.limit > 1) {
      if (!this.isTopicSelected(id) || !this.localTopics.length) {
        this.localTopics.push(id)
      } else {
        this.localTopics = this.localTopics.filter(t => t !== id)
      }
    } else {
      this.localTopics = []
      this.localTopics.push(id)

      this.handleOkClick()
    }
  }

  setPiTopics():void {
    this.localTopics = cloneDeep(this.selectedTopics)
  }

  checkUnexistedTopics():void {
    this.localTopics = this.localTopics.filter(t => this.topics.items.findIndex(existedTopic => existedTopic.value === t) !== -1)

    this.updateTopics()
  }

  mounted():void {
    this.setPiTopics()

    this.checkUnexistedTopics()
  }
}
